console.log("restore-share-cart.js loaded");

document.addEventListener("DOMContentLoaded", async () => {
  const container = document.querySelector("#share-cart-restore");

  if (!container) {
    console.log("No #share-cart-restore found");
    return;
  }

  const message = document.querySelector("#share-cart-message");
  const button = document.querySelector("#restore-share-cart-btn");

  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");

  console.log("Share cart token:", token);

  if (!token) {
    message.textContent = "Invalid share cart link.";
    return;
  }

  let sharedCart = null;

  try {
    const getUrl =
      "https://urwizards-share-cart.tysonyu774.workers.dev/get?token=" +
      encodeURIComponent(token);

    console.log("Fetching shared cart:", getUrl);

    const response = await fetch(getUrl);
    const data = await response.json();

    console.log("Worker get status:", response.status);
    console.log("Worker get data:", data);

    if (!response.ok) {
      message.textContent = data.error || "Shared cart not found.";
      return;
    }

    sharedCart = data;

    if (!sharedCart.items || sharedCart.items.length === 0) {
      message.textContent = "This shared cart is empty.";
      return;
    }

    message.textContent =
      "This shared cart contains " +
      sharedCart.items.length +
      " item(s).";

    button.style.display = "inline-block";
  } catch (error) {
    console.error("Unable to load shared cart:", error);
    message.textContent = "Unable to load shared cart.";
    return;
  }

  button.addEventListener("click", async () => {
    try {
      button.disabled = true;
      button.textContent = "Restoring...";

      await fetch("/cart/clear.js", {
        method: "POST"
      });

      const items = sharedCart.items.map((item) => {
        const cartItem = {
          id: item.variant_id || item.id,
          quantity: item.quantity || 1
        };

        if (item.properties && Object.keys(item.properties).length > 0) {
          cartItem.properties = item.properties;
        }

        if (item.selling_plan) {
          cartItem.selling_plan = item.selling_plan;
        }

        return cartItem;
      });

      console.log("Adding items to cart:", items);

      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items
        })
      });

      const addData = await addResponse.json();

      console.log("Cart add status:", addResponse.status);
      console.log("Cart add data:", addData);

      if (!addResponse.ok) {
        message.textContent =
          addData.description || "Unable to restore cart.";

        button.disabled = false;
        button.textContent = "Restore cart";
        return;
      }

      message.textContent = "Cart restored successfully.";
      window.location.href = "/cart";
    } catch (error) {
      console.error("Failed to restore cart:", error);

      message.textContent = "Failed to restore cart.";

      button.disabled = false;
      button.textContent = "Restore cart";
    }
  });
});